import React, { Component } from 'react';

class FormElements extends Component {
    render() {
        return (
            <div className="form-elements">
                <div className="col-md-12" style={{
                    backgroundColor: 'var(--card, #fff)',
                    border: '1px solid var(--border, #ccc)',
                    padding: 'calc(var(--spacing, 16px) * 6)',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 'var(--radius, 10px)',
                    boxShadow: 'var(--shadow-sm)'

                }}>
                    <h4 style={{
                        color: 'var(--card-foreground, #000)',
                        fontWeight: '700',
                        marginBottom: 'calc(var(--spacing, 4px) * 8)',
                        fontFamily: "var(--font-titles)"
                    }}>
                        Form elements
                    </h4>
                    <div className="row row-inputs">
                        <div className="col-md-6">
                            <label htmlFor="inputText1" style={{ color: 'var(--card-foreground, #000)', fontWeight: '600', fontFamily: "var(--font-body)" }}>Input field</label>
                            <input
                                type="text"
                                id="inputText1"
                                className="spark-text-input focusable-input"
                                placeholder="Enter a value"
                                style={{
                                    width: '100%',
                                    height: '36px',
                                    minWidth: '0',
                                    padding: 'calc(var(--spacing, 4px) * 3) calc(var(--spacing, 4px) * 3)',
                                    fontSize: '14px',
                                    lineHeight: '1.5',
                                    color: 'var(--foreground, #000)',
                                    backgroundColor: 'transparent',
                                    border: '1px solid var(--border, #d1d5db)',
                                    borderRadius: 'var(--radius, 10px)',
                                    marginBottom: '10px',
                                    outline: 'none',
                                    transition: 'color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-color 0.15s ease-in-out',
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = 'var(--ring, #6366f1)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = 'var(--border, #d1d5db)';
                                }}
                            />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="inputText2" style={{ color: 'var(--card-foreground, #000)', fontWeight: '600', fontFamily: "var(--font-body)" }}>Disabled input field</label>
                            <input
                                type="text"
                                id="inputText2"
                                disabled
                                className="spark-text-input"
                                placeholder="Placeholder text"
                                style={{
                                    width: '100%',
                                    height: '36px',
                                    minWidth: '0',
                                    padding: 'calc(var(--spacing, 4px) * 3) calc(var(--spacing, 4px) * 3)',
                                    fontSize: '14px',
                                    lineHeight: '1.5',
                                    color: 'var(--muted-foreground, #6b7280)',
                                    backgroundColor: 'var(--muted, #f9fafb)',
                                    border: '1px solid var(--border, #d1d5db)',
                                    borderRadius: 'var(--radius, 10px)',
                                    marginBottom: '10px',
                                    outline: 'none',
                                    opacity: '0.5',
                                    cursor: 'not-allowed',
                                    pointerEvents: 'none',
                                }}
                            />
                        </div>
                    </div>
                    <div className='row ml-0' style={{ margin: 'calc(var(--spacing, 4px) * 4) 0px' }}>
                        <div className='col-md-6'>
                            <label className='checkbox' htmlFor="checkbox1" style={{
                                color: 'var(--card-foreground, #000)',
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                fontFamily: "var(--font-body)"
                            }}>
                                <input
                                    type="checkbox"
                                    id="checkbox1"
                                    checked
                                    className="focusable-input"
                                    style={{
                                        width: '18px',
                                        height: '18px',
                                        marginRight: 'calc(var(--spacing, 4px) * 2)',
                                        accentColor: 'var(--primary, #309AB5)',
                                        cursor: 'pointer',
                                        color: 'var(--primary-foreground, #000)'
                                    }}
                                />
                                <svg
                                    class="check-icon"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="var(--primary-foreground, #fff)"
                                    stroke-width="3"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                >
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                                Checkbox
                            </label>
                        </div>
                        <div className='col-md-6'>
                            <label htmlFor="radio1" style={{
                                color: 'var(--card-foreground, #000)',
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                fontFamily: "var(--font-body)"
                            }}>
                                <input
                                    type="radio"
                                    id="radio1"
                                    name="radioGroup"
                                    className="focusable-input"
                                    style={{
                                        width: '18px',
                                        height: '18px',
                                        marginRight: 'calc(var(--spacing, 4px) * 2)',
                                        accentColor: 'var(--primary, #309AB5)',
                                        cursor: 'pointer',
                                        color: 'var(--primary-foreground, #000)'
                                    }}
                                />
                                Radio
                            </label>
                        </div>
                    </div>
                    <div className="row ml-0" style={{ margin: 'calc(var(--spacing, 4px) * 4) 0px' }}>
                        <div className='col-md-6'>
                            <label htmlFor="checkbox2" style={{
                                color: 'var(--muted-foreground, #6b7280)',
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'not-allowed',
                                opacity: '0.5',
                                fontFamily: "var(--font-body)"
                            }}>
                                <input
                                    type="checkbox"
                                    id="checkbox2"
                                    disabled
                                    checked
                                    style={{
                                        width: '18px',
                                        height: '18px',
                                        marginRight: 'calc(var(--spacing, 4px) * 2)',
                                        accentColor: 'var(--primary, #309AB5)',
                                        cursor: 'not-allowed',
                                        opacity: '0.5'
                                    }}
                                />
                                Disabled checkbox
                            </label>
                        </div>
                        <div className='col-md-6'>
                            <label htmlFor="radio2" style={{
                                color: 'var(--muted-foreground, #6b7280)',
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'not-allowed',
                                opacity: '0.5',
                                fontFamily: "var(--font-body)"
                            }}>
                                <input
                                    type="radio"
                                    id="radio2"
                                    name="radioGroup"
                                    disabled
                                    style={{
                                        width: '18px',
                                        height: '18px',
                                        marginRight: 'calc(var(--spacing, 4px) * 2)',
                                        accentColor: 'var(--muted, #f9fafb)',
                                        cursor: 'not-allowed',
                                        opacity: '0.5'
                                    }}
                                />
                                Disabled radio
                            </label>
                        </div>
                    </div>
                    <div className="row row-inputs">
                        <div className="col-md-6">
                            <button
                                className="spark-button spark-button--secondary in-context-button--secondary focusable-element"
                                style={{
                                    backgroundColor: 'var(--secondary, #f8f9fa)',
                                    color: 'var(--secondary-foreground, #333)',
                                    border: '1px solid var(--border, #ccc)',
                                    padding: '10px',
                                    margin: 'calc(var(--spacing, 4px) * 4) 0px',
                                    borderRadius: 'var(--radius, 10px)',
                                    fontSize: '14px',
                                }}
                            >
                                Secondary button
                            </button>
                        </div>
                        <div className="col-md-6">
                            <button
                                className="spark-button spark-button--primary in-context-button--primary focusable-element"
                                style={{
                                    backgroundColor: 'var(--primary-button, #309AB5)',
                                    color: 'var(--primary-button-foreground, #fff)',
                                    border: '1px solid var(--border, #ccc)',
                                    margin: 'calc(var(--spacing, 4px) * 4) 0px',
                                    padding: '10px',
                                    borderRadius: 'var(--radius, 10px)',
                                    fontSize: '14px',

                                }}
                            >
                                Primary button
                            </button>
                        </div>
                    </div>
                    <div className='row row-inputs'>
                        <div className="col-md-6">
                            <button
                                disabled
                                className="spark-button spark-button--secondary-disabled in-context-button--secondary"
                                style={{
                                    backgroundColor: 'var(--secondary, #fff)',
                                    color: 'var(--secondary-foreground, #999)',
                                    border: '1px solid var(--border, #ccc)',
                                    padding: 'calc(var(--spacing, 4px) * 2.5) calc(var(--spacing, 4px) * 5)',
                                    margin: 'calc(var(--spacing, 4px) * 4) 0px',
                                    borderRadius: 'var(--radius, 10px)',
                                    fontSize: '14px',
                                    opacity: '0.6',
                                }}
                            >
                                Disabled secondary button
                            </button>
                        </div>
                        <div className="col-md-6">
                            <button
                                disabled
                                className="spark-button spark-button--primary-disabled in-context-button--primary"
                                style={{
                                    backgroundColor: 'var(--primary-button, #309AB5)',
                                    color: 'var(--primary-foreground, #666)',
                                    border: '1px solid var(--border, #ccc)',
                                    padding: 'calc(var(--spacing, 4px) * 2.5) calc(var(--spacing, 4px) * 5)',
                                    margin: 'calc(var(--spacing, 4px) * 4) 0px',
                                    borderRadius: 'var(--radius, 10px)',
                                    fontSize: '14px',
                                    opacity: '0.6',
                                }}
                            >
                                Disabled primary button
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FormElements;



// WEBPACK FOOTER //
// ./src/components/pages/in-context/components/FormElements.js